import { axiosRequest } from '@/util/axios-request'

// 二维码扫码状态查询
export const commonDeptList = data =>
  axiosRequest({
    url: '/web/Organization/commonDeptList',
    method: 'GET',
    params: data
  })

// 审批流—获取条件配置列表
export const getConditionList = data =>
  axiosRequest({
    url: '/web/workflow/getConditionList',
    method: 'GET',
    params: data
  })

// 审批流—筛选项
export const selectApi = data =>
  axiosRequest({
    url: 'web/workflow/init',
    method: 'GET'
  })

// 审批流—列表
export const lists = data =>
  axiosRequest({
    url: '/web/workflow/lists',
    method: 'GET',
    params: data
  })

// 获取审批流
export const getWorkFlow = data =>
  axiosRequest({
    url: '/web/workflow/get',
    method: 'GET',
    params: data
  })

// 保存审批配置
export const workFlowSave = data =>
  axiosRequest({
    url: '/web/workflow/save',
    data
  })

// 审批流—更新
export const workUpdateSave = data =>
  axiosRequest({
    url: '/web/workflow/update',
    data
  })

// 审批流—启停操作
export const switchStatus = data =>
  axiosRequest({
    url: '/web/workflow/switchStatus',
    data
  })

// 审批人抄送人选项
export const getWorkflowNoteInfo = params =>
  axiosRequest({ url: '/web/Workflow/getWorkflowNoteConfig', params, method: 'GET' })

// 获取币种
export const getCurrency = data =>
  axiosRequest({
    url: '/web/workflow/getCurrency',
    data
  })

export const getWorkFlowList = data =>
  axiosRequest({
    url: '/web/workflow/workFlowList',
    data
  })

export const insertOrUpdateGroup = data =>
  axiosRequest({
    url: '/web/workflow/insertOrUpdateGroup',
    data
  })

export const delGroup = data =>
  axiosRequest({
    url: '/web/workflow/delGroup',
    data
  })

export const getGroup = data =>
  axiosRequest({
    url: '/web/workflow/getGroup',
    data
  })

export const getLanguage = data =>
  axiosRequest({
    url: '/web/workflow/getLanguage',
    data
  })

export const saveLanguage = data =>
  axiosRequest({
    url: '/web/workflow/saveLanguage',
    data
  })

export const getFlowTypes = data =>
  axiosRequest({
    url: '/web/workflow/getFlowTypes',
    data
  })
